import React, { useContext } from 'react';
import Context from '../../_context';
import styled from 'styled-components';
import { Row, Col, Container, Hidden } from 'react-grid-system';
import { Button } from '../../_components/buttons';
import { ServiceCarousel, ReviewCarousel } from '../../_components/carousels';
import { navigate } from 'gatsby';

const MainCont = styled.section`  
  position: relative;
  padding-bottom: 6rem;
`
const HeroInfoCont = styled.div`
  background-color: ${props => props.theme.main.primaryColor};
  min-height: calc(50vh - 4rem);
  color: #ffffff;
`
const DescriptionCont = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
  height: 100%;
  padding: 4rem 0;
`
const Title = styled.h2`
  font-size: 40px;
  color: #b79c4e;
`
const Description = styled.p`
  margin: 2rem 0 4rem;
`
const HeroImage = styled.img`
  width: 50vw;
  height: 100%;
  object-fit: cover;
  object-fit: center;
`
const TitleService = styled(Title)`
  color: ${props => props.theme.main.primaryColor};
  padding-top: 4rem;
`
const SubTitleService = styled(Description)`
  font-weight: bold;
  margin: 4rem 0 0;
`
const TitleQuoteCont = styled.div`
  padding-top: 4rem;
`
const SvgCont = styled.svg`
  margin: 2rem 0;
  fill: ${props => props.theme.main.primaryColor};
`
const QuoteCarouselCont = styled.div`
  padding-top: 0rem;
  @media(min-width: 768px){
    padding-top: 2rem;
  }
`
const CarouselCont = styled.div`
  position: relative;
`


export default ()=> {
  const state = useContext(Context).home;
  return(
    <MainCont>
      <HeroInfoCont>
        <Container>
          <Row>
            <Col xs={12} md={6}>
              <DescriptionCont>
                <Title>
                  {state.about.banner.title}
                </Title>
                <Description>
                  {state.about.banner.subTitle}
                </Description>
                <Button block onClick={()=> navigate("/about")}>
                  {state.about.banner.buttonText}
                </Button>
              </DescriptionCont>
            </Col>
            <Hidden xs>
              <Col md={6}>
                <HeroImage
                  //src={state.about.banner.image}
                  src={"/about-2.jpg"}
                />
              </Col>
            </Hidden>
          </Row>
        </Container>
      </HeroInfoCont>
      <Container>
        <Row gutterWidth={128}>
          <Col xs={12} md={6}>
            <TitleService>Ofrecemos asesoría profesional e integral</TitleService>
            <SubTitleService>Nuestros servicios son diferenciadores, conócenos.</SubTitleService>
            <CarouselCont>
              <ServiceCarousel />
            </CarouselCont>
          </Col>
          <Col xs={12} md={6}>
            <TitleQuoteCont>
              <SvgCont width="84" height="101" viewBox="0 0 84 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M56 48.3737L56 0H84L84 48.3737L72.6923 101H58.1538L66.2308 48.3737H56ZM0 48.3737L0 0L28 0L28 48.3737L16.6923 101H2.15385L10.2308 48.3737H0Z"/>
              </SvgCont>
            </TitleQuoteCont>
            <QuoteCarouselCont>
              <ReviewCarousel />
            </QuoteCarouselCont>
          </Col>          
        </Row>
      </Container>
    </MainCont>
  )
}